import App from './components/App';
import { withRouter } from 'react-router'

export default withRouter(App);